module.exports = __webpack_public_path__ + "img/noun_start up.e3a6d97f.svg";